import { render, staticRenderFns } from "./MealPlansGrid.vue?vue&type=template&id=1123c230&scoped=true&"
import script from "./MealPlansGrid.vue?vue&type=script&lang=js&"
export * from "./MealPlansGrid.vue?vue&type=script&lang=js&"
import style0 from "./MealPlansGrid.vue?vue&type=style&index=0&id=1123c230&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1123c230",
  null
  
)

export default component.exports